import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const RouterIcon = forwardRef<SVGSVGElement, IconProps>(function RouterIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 5.97368C1.66569 5.97368 1.8 6.11507 1.8 6.28947V7.13158C1.8 7.30598 1.66569 7.44737 1.5 7.44737C1.33431 7.44737 1.2 7.30598 1.2 7.13158V6.28947C1.2 6.11507 1.33431 5.97368 1.5 5.97368Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.1 5.97368C3.26569 5.97368 3.4 6.11507 3.4 6.28947V7.13158C3.4 7.30598 3.26569 7.44737 3.1 7.44737C2.93431 7.44737 2.8 7.30598 2.8 7.13158V6.28947C2.8 6.11507 2.93431 5.97368 3.1 5.97368Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8 6.71053C4.8 6.53612 4.93431 6.39474 5.1 6.39474H6.7C6.86569 6.39474 7 6.53612 7 6.71053C7 6.88493 6.86569 7.02632 6.7 7.02632H5.1C4.93431 7.02632 4.8 6.88493 4.8 6.71053Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.27688 5.40987C0.883164 5.40987 0.558399 5.74481 0.558399 6.1563V7.17345C0.558399 7.58248 0.880795 7.91987 1.27688 7.91987H6.72313C7.11616 7.91987 7.4416 7.58178 7.4416 7.17345V6.1563C7.4416 5.74726 7.11921 5.40987 6.72313 5.40987H1.27688ZM0 6.1563C0 5.42301 0.576125 4.82974 1.27688 4.82974H6.72313C7.42896 4.82974 8 5.42828 8 6.1563V7.17345C8 7.90217 7.42456 8.5 6.72313 8.5H1.27688C0.571049 8.5 0 7.90147 0 7.17345V6.1563Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.62156 1.79308C1.52722 1.66637 1.54961 1.48419 1.67158 1.38617C3.14399 0.202937 5.07152 0.206406 6.54562 1.3858C6.66778 1.48355 6.69055 1.66567 6.59647 1.7926C6.50238 1.91952 6.32708 1.94317 6.20491 1.84543C4.93087 0.826093 3.2837 0.824085 2.01323 1.84504C1.89126 1.94306 1.71591 1.91979 1.62156 1.79308Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.22451 3.00477C2.13006 2.87814 2.15231 2.69594 2.2742 2.59782C3.38092 1.70689 4.83476 1.71062 5.94283 2.5973C6.065 2.69506 6.08775 2.87719 5.99366 3.0041C5.89956 3.13102 5.72425 3.15466 5.60209 3.0569C4.69381 2.3301 3.52059 2.32836 2.61622 3.05639C2.49433 3.15451 2.31896 3.1314 2.22451 3.00477Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.05313 4.2155C2.95908 4.08855 2.9819 3.90643 3.1041 3.80872C3.70675 3.32685 4.50211 3.32327 5.10846 3.80885C5.23059 3.90665 5.25328 4.08879 5.15914 4.21567C5.065 4.34255 4.88968 4.36612 4.76756 4.26832C4.3631 3.94442 3.84756 3.94631 3.44467 4.26845C3.32247 4.36616 3.14717 4.34245 3.05313 4.2155Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
